import React, { useState, useEffect } from 'react'
import './ShoppingListEnd.min.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Outlet, Link } from "react-router-dom";
import axios from 'axios';
import ShoppingListFinished from './ShoppingListFinished';
import { ipAddress } from '../../ipAddress';

interface Shops {
  id: number,
  name: string,
  date: string,
  isDone: number,
}

const ShoppingListEnd = () => {
  const [shopsEnd, setShopsEnd] = useState<Shops[]>([])


  const ShoppingListEnd2 = () => {
    axios.post(ipAddress + "/getShopsListEnd")
      .then((response) => {
        setShopsEnd(response.data)

      })
      .catch((err) => {
        console.log('Error!')
      })
  }

  for (let i = 0; i < shopsEnd.length; i++) {
    var date2 = new Date();
    let date1 = new Date(shopsEnd[i].date);
    //var dateFormart = new Date(`"${month}/${day}/${year}"`);
    var timeDiff = Math.abs(date2.getTime() - date1.getTime());
    var diffDays = Math.floor(timeDiff / (1000 * 3600 * 24)); 
    if(diffDays > 7 ){
      axios.post(ipAddress + "/deleteShop", {
          id: shopsEnd[i].id
        })
        axios.post(ipAddress + "/deleteAllThings", {
          shopId: shopsEnd[i].id
        })

        
        
    }

  }

  useEffect(() => {
    ShoppingListEnd2()

  }, [shopsEnd])



  return (

    <div className='shoppingListEnd'>
      <div className='title'>
        <Link to='..'> <FontAwesomeIcon id='faArrowLeft' icon={faArrowLeft} /></Link>
        <span id='title'>Lista zakupów</span>
      </div>
      <div className='shoppingListEnd2'>
        <Link to='/ShoppingList'>Do kupienia</Link>
        <Link to='/ShoppingList/Kupione'>Kupione</Link>
      </div>
      <div>
        {shopsEnd.map((shop) => (
          <ShoppingListFinished shop={shop} key={shop.id} />
        )
        )}

      </div>
      <Outlet />
    </div>
  )
}

export default ShoppingListEnd